/**
 * O erro de um envio em pt-BR. O da Meta chega como `#código título`; os códigos são os que mais
 * apareceram nos envios do HQ. O que não tem tradução aparece como veio.
 */
export class ReportSendError {
  private static readonly META_CODE = /#(\d+)/;
  private static readonly META: Record<string, string> = {
    '100': 'A Meta recusou um parâmetro do envio',
    '130472': 'A Meta deixou o número num teste dela e não entregou',
    '131000': 'A Meta falhou sem dizer o motivo',
    '131005': 'A Meta negou o acesso ao número que envia',
    '131008': 'Faltou um parâmetro do modelo',
    '131026': 'O número não recebe: sem WhatsApp ou com versão antiga',
    '131031': 'A conta do WhatsApp que envia está bloqueada',
    '131047': 'Fora da janela de 24 h de conversa com o contato',
    '131049': 'A Meta segurou a mensagem para não cansar o contato',
    '131056': 'Mensagens demais para o mesmo número em pouco tempo',
    '132005': 'O texto do modelo passou do tamanho depois de preenchido',
  };
  private static readonly EMAIL_REJECTED = /MessageRejected|not verified|rejected/i;

  static label(error: string): string {
    const code = ReportSendError.META_CODE.exec(error)?.[1];
    const meta = code ? ReportSendError.META[code] : undefined;
    if (meta) return meta;
    if (ReportSendError.EMAIL_REJECTED.test(error)) return 'O provedor de e-mail recusou o endereço';
    return error;
  }
}
